import { gql } from "@apollo/client";
import { RHTVVideoFragment } from "./Video";
import { ACFMediaFragment } from "../ACF/Media";

export const RHTVChannelFragment = gql`
  ${RHTVVideoFragment}
  ${ACFMediaFragment}
  fragment RhtvChannel on RhtvChannel {
    title
    slug
    uri
    rhtvChannelContent {
      excerpt
      previewVideo
      thumbnail {
        ...ACFMedia
      }
      rhtvVideos(first: 100) {
        nodes {
          ...RhtvVideo
        }
      }
    }
  }
`